import {createFileRoute} from '@tanstack/react-router';
import {AuthCallbackPage} from '@/features/auth';
import {authSignedGuard, can} from '@/libs/router';

interface AuthCallbackSearch {
  accessToken?: string;
  isSignUp?: boolean;
  isAdmin?: boolean;
}

export const Route = createFileRoute('/_auth/auth/callback')({
  beforeLoad: can([authSignedGuard]),
  component: () => <AuthCallbackPage />,
  validateSearch: (search: AuthCallbackSearch) => {
    return search;
  },
});
